import { httpCreate } from './http';
const http = httpCreate('/srv/rtmp-mirror');
export const rtmpMirror = {
	// 新增分发平台
	puberLive(activityId, data) {
		return http.post(`/puber/${activityId}`, data);
	},
    // 获取抖音绑定二维码
    getDouyinQrCode() {
        return http.post(`/`)
    },
	// 开启直播分发
	openLive(activityId, data) {
		return http.post(`/open/${activityId}`, data);
	},
	// 关闭直播分发
	closeLive(activityId, data) {
		return http.post(`/close/${activityId}`, data);
	},
	// 修改分发平台信息
	updatePuber(activityId, data) {
		return http.put(`/puber/${activityId}`, data);
	},
	// 删除分发平台信息
	delPuber(activityId, puberId) {
		return http.delete(`/puber/${activityId}/${puberId}`);
	},
	//获取分发配置信息
	getPuber(activityId) {
		return http.get(`/${activityId}`);
	},
	//开启或关闭分发平台
	openOrClosePuber(action, activityId, puberId) {
		return http.put(`/puber/${action}/${activityId}/${puberId}`);
	},
	openPuber(activityId, puberId) {
		return http.put(`/puber/open/${activityId}/${puberId}`);
	},
	closePuber(activityId, puberId) {
		return http.put(`/puber/close/${activityId}/${puberId}`);
	},
	getKsPuber(activityId, kuaishouId) {
		return http.get(`/puber/ks-config/${activityId}/${kuaishouId}`);
	},
	saveKsPuber(activityId, kuaishouId, data) {
		return http.put(`/puber/ks-config/${activityId}/${kuaishouId}`, data);
	},
};
